export const SESSION_REFRESH_PERIOD = 5_000 // 5s
export const WS_RECONNECT_INTERVAL = 600 // 600ms

export const SESSION_DOMAIN = 'ondevbook.com'
export const WS_PORT = 49982
export const WS_ROUTE = '/ws'
